import { useState, useEffect } from 'react';
import paymentService from '../services/paymentService';

export const usePayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const { data, error } = await paymentService.getAllPayments();
      if (error) {
        setError(error);
      } else {
        setPayments(data);
        setError(null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const recordPayment = async (paymentData) => {
    try {
      const { data, error } = await paymentService.recordPayment(paymentData);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setPayments(prev => [data, ...prev]);
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const updatePayment = async (id, paymentData) => {
    try {
      const { data, error } = await paymentService.updatePayment(id, paymentData);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setPayments(prev => prev.map(payment => payment.id === id ? data : payment));
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const deletePayment = async (id) => {
    try {
      const { data, error } = await paymentService.deletePayment(id);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setPayments(prev => prev.filter(payment => payment.id !== id));
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  return {
    payments,
    loading,
    error,
    refetch: fetchPayments,
    recordPayment,
    updatePayment,
    deletePayment
  };
};

export const usePaymentMethods = () => {
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMethods = async () => {
      try {
        const { data } = await paymentService.getPaymentMethods();
        setMethods(data);
      } catch (error) {
        console.error('Error fetching payment methods:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMethods();
  }, []);

  return { methods, loading };
};

export const usePaymentStatistics = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await paymentService.getPaymentStatistics();
        setStats(data);
      } catch (error) {
        console.error('Error fetching payment statistics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return { stats, loading };
};